import React from 'react'
import Form from './container'
import PageTemplate from 'components/page-template'

export default () => (
  <PageTemplate
    title='Create a Mentions Experience'
    description="that's where automagic happens"
    className='br-experience widgetBuilder'
  >
    <Form experiencePlatform={'twitter'} experienceType={'mentions'} />
  </PageTemplate>
)



// WEBPACK FOOTER //
// ./src/pages/widgets/mentions/create/index.js